class GridSwitcher extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
    this.mobileMq = window.matchMedia('(max-width: 768px)')
    this.buttonActiveClass = 'clc-ProductGrid_GridButton-active'

    this.gridClasses = {
      single: 'prd-List_Items-single',
      small: 'prd-List_Items-small',
      medium: 'prd-List_Items-medium',
      large: 'prd-List_Items-large',
    }
  }

  setupListeners () {
    super.setupListeners()

    this.handleGridSwitch = this.handleGridSwitch.bind(this)
    this.toggleActiveClass = this.toggleActiveClass.bind(this)
    this.updateGridClass = this.updateGridClass.bind(this)

    if (!this.els?.button?.elements) {
      console.error('Button elements are not defined')
      return
    }

    this.els?.button?.elements.forEach(button => {
      this.listeners.add(button, 'click', evt => {
        const button = evt.target.closest('button')

        evt.preventDefault()
        this.handleGridSwitch(button)
      })
    })

    this.listeners.add(window, 'resize', () => {
      if (this.mobileMq.matches) {
        const mobileButton = document.querySelector('[data-grid-view="large"]')

        this.handleGridSwitch(mobileButton)
      }
    })
  }

  toggleActiveClass (activeButton, activeClass) {
    if (!this.els?.button?.elements) {
      console.error('Button elements are not defined')
      return
    }

    this.els?.button?.elements.forEach(button => {
      button.classList.toggle(activeClass, button === activeButton)
    })
  }

  async updateCartAttributes (layoutData) {
    try {
      await window.BAO.Cart.updateCartAttributes(layoutData)
    } catch (error) {
      console.error('Failed to update cart attributes:', error)
    }
  }

  updateGridClass (element, layout) {
    Object.values(this.gridClasses).forEach(gridClass => {
      element.classList.remove(gridClass)
    })

    const newClass = this.gridClasses[layout]
    if (newClass) {
      element.classList.add(newClass)
    }
  }

  async handleGridSwitch (button) {
    if (!button) {
      console.error('No button found for the event target')
      return
    }

    const layoutValue = button.dataset.gridView
    if (!layoutValue) {
      console.error('No grid view value found on the button')
      return
    }

    const layoutData = {
      'grid-layout': layoutValue,
    }

    this.toggleActiveClass(button, this.buttonActiveClass)
    this.updateGridClass(this.externalEls?.productList?.element, layoutValue)

    try {
      await this.updateCartAttributes(layoutData)
    } catch (error) {
      console.error('Failed to update cart attributes:', error)
    }
  }
}

if (!customElements.get('grid-switcher')) {
  customElements.define('grid-switcher', GridSwitcher)
}
